import api from './api';

// Every call carries org_id so a superuser acting on a selected instance hits
// that org rather than silently falling back to their own. Org-admins may pass
// it too; the backend pins them to their own organisation regardless.
const withOrg = (orgId, params = {}) =>
  orgId ? { ...params, org_id: orgId } : params;

const eventsService = {
  list: async (includeInactive = false, orgId = null) => {
    const params = withOrg(orgId, includeInactive ? { include_inactive: true } : {});
    const response = await api.get('/api/v1/admin/events/', { params });
    return response.data;
  },

  create: async (eventData, orgId = null) => {
    const response = await api.post('/api/v1/admin/events/', eventData, {
      params: withOrg(orgId),
    });
    return response.data;
  },

  update: async (eventId, eventData, orgId = null) => {
    const response = await api.patch(`/api/v1/admin/events/${eventId}`, eventData, {
      params: withOrg(orgId),
    });
    return response.data;
  },

  delete: async (eventId, orgId = null) => {
    const response = await api.delete(`/api/v1/admin/events/${eventId}`, {
      params: withOrg(orgId),
    });
    return response.data;
  },
};

export default eventsService;
